import {memo} from 'react';

import styled from 'styled-components';

import SocialNetworks from '~/shared/components/PageFooter/10bis/FooterSection/SocialNetworks';
import {media} from '~/shared/theme/media';
import {googlePlayLink, iTunesLink} from '~/shared/config';

import FooterLogo from '../assets/footerLogo.svg?react';
import FooterDownloadTheApp from '../../shared/FooterDownloadTheApp';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 40px 0 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  ${media.minLargeMobile`
    align-items: flex-start;
    flex-direction: row;
    gap: 68px;
    padding: 60px 0 24px;
  `}
  ${media.minLargeTablet`
    align-items: flex-end;
    padding: 60px 0 40px;
  `}
`;

const StyledFooterDownloadTheApp = styled(FooterDownloadTheApp)`
  ${media.minLargeMobile`
    .download-the-app-wrapper {
      flex-direction: column;
    }
  `}
  ${media.minLargeTablet`
    .download-the-app-wrapper {
      flex-direction: row;
    }
    .download-the-app-wrapper img {
      margin-left: 0;
      margin-right: 0;
    }
  `}
`;

type FooterTopSectionProps = {
  isIOS?: boolean;
  isAndroid?: boolean;
};

const FooterTopSection = ({isAndroid, isIOS}: FooterTopSectionProps) => {
  return (
    <Root>
      <FooterLogo />
      <SocialNetworks />
      <StyledFooterDownloadTheApp isIOS={isIOS} isAndroid={isAndroid} iosLink={iTunesLink} androidLink={googlePlayLink} />
    </Root>
  );
};

export default memo(FooterTopSection);
